import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import type { UpdateSmartLabIrrigationSettingsRequest } from '@/lib/api/smartlab-irrigation-settings-api'
import { smartLabIrrigationSettingsApi } from '@/lib/api/smartlab-irrigation-settings-api'
import { formatApiError } from '@/lib/format-api-error'
import { m } from '@/lib/paraglide/messages'

export const smartLabIrrigationSettingsKeys = {
    all: ['smartlab-irrigation-settings'] as const,
}

export function useSmartLabIrrigationSettings() {
    return useQuery({
        queryKey: smartLabIrrigationSettingsKeys.all,
        queryFn: async () => {
            const res = await smartLabIrrigationSettingsApi.get()
            return res.data ?? null
        },
    })
}

export function useUpdateSmartLabIrrigationSettings() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: async (data: UpdateSmartLabIrrigationSettingsRequest) => {
            const res = await smartLabIrrigationSettingsApi.update(data)
            return res.data
        },
        onSuccess: () => {
            void qc.invalidateQueries({
                queryKey: smartLabIrrigationSettingsKeys.all,
            })
            toast.success(m.smartlab_irrigation_settings_save_success())
        },
        onError: (err) => {
            // Backend trả code (SMARTLAB_IRRIGATION_*); formatApiError dịch
            // code đó, còn lỗi không có code thì dùng câu dự phòng.
            const payload = formatApiError(
                err,
                m.smartlab_irrigation_settings_save_error(),
            )
            toast.error(payload.title, { description: payload.description })
        },
    })
}
